import React from 'react';
import { StarIcon } from 'lucide-react';
import { AddressForm } from '../AddressForm';
import { images } from '../../data/images';
const facts = [{
  value: '€ 640',
  label: 'gemiddelde besparing per jaar'
}, {
  value: '1 dag',
  label: 'installatie door eigen monteurs'
}, {
  value: '10 jaar',
  label: 'garantie op batterij'
}];
export function HomeHero() {
  return <section className="relative -mt-[76px] overflow-hidden bg-ink" data-id="element-155" data-mp="296dm9k7dl8sl">
      <img src={images.heroWide} alt="Stroomkluis thuisbatterij aan de muur van een garage, met zicht op een Nederlandse straat" className="absolute inset-0 h-full w-full object-cover object-[65%_center]" data-id="element-156" data-mp="2wuwxa7ht7zod" />
      <div className="absolute inset-0 bg-ink/55 lg:bg-ink/45" aria-hidden="true" data-id="element-157" data-mp="2s3est9gkvgyn" />

      <div className="relative mx-auto flex min-h-[780px] max-w-[1440px] items-end px-4 pb-12 pt-[140px] sm:px-6 lg:min-h-[880px] lg:px-10 lg:pb-20" data-id="element-158" data-mp="2s125shvyqgeq">
        <div className="grid w-full gap-10 lg:grid-cols-[1fr_430px] lg:items-end lg:gap-16" data-id="element-159" data-mp="3kkr6mf2x763v">
          <div className="text-canvas" data-id="element-160" data-mp="owacq2xx68ms">
            <div className="inline-flex items-center gap-2.5 rounded-full bg-ink/50 px-3.5 py-2 text-[14px] backdrop-blur" data-id="element-161" data-mp="ot4nmnpaj6r2">
              <span className="flex" aria-hidden="true" data-id="element-162" data-mp="xnj2wq9tmha6">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-volt text-volt" data-id="element-163" data-mp="sx2mcxapefjl" />)}
              </span>
              <span data-id="element-164" data-mp="17kxg8h0g6py9">
                <strong className="font-semibold" data-id="element-165" data-mp="17k5jv3z10o6x">4,9</strong> uit 1.240 Google-reviews
              </span>
            </div>

            <h1 className="mt-6 max-w-4xl text-[52px] font-semibold leading-[0.94] tracking-tightest sm:text-7xl lg:text-[96px]" data-id="element-166" data-mp="12oq7kggo30cm">
              Jouw zonnestroom.
              <br data-id="element-167" data-mp="1cm4osiaezt5z" />
              <span className="text-volt" data-id="element-168" data-mp="1cll5ax548wpu">Ook na zonsondergang.</span>
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-canvas/85 sm:text-xl" data-id="element-169" data-mp="3iejkczs8h4se">
              De Stroomkluis thuisbatterij bewaart je zonnestroom overdag en laadt slim bij als stroom goedkoop is. Klaar
              voor het einde van de salderingsregeling.
            </p>

            <dl className="mt-10 hidden max-w-2xl grid-cols-3 border-t border-canvas/20 pt-6 sm:grid" data-id="element-170" data-mp="1mbohr4efmpmh">
              {facts.map(f => <div key={f.label} className="pr-6" data-id="element-171" data-mp="1rbt255igo4hz">
                  <dt className="sr-only" data-id="element-172" data-mp="1w9uihioi5ppr">{f.label}</dt>
                  <dd data-id="element-173" data-mp="1w6gj8jb4xwmj">
                    <span className="block font-display text-3xl font-semibold tracking-tight" data-id="element-174" data-mp="20ay0aaq41vtm">{f.value}</span>
                    <span className="mt-1 block text-[14px] text-canvas/70" data-id="element-175" data-mp="258poourjqzt2">{f.label}</span>
                  </dd>
                </div>)}
            </dl>
          </div>

          <div className="rounded-[28px] bg-canvas p-6 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)] sm:p-8" data-id="element-176" data-mp="2ezu41vl4wmof">
            <h2 className="text-[28px] font-semibold leading-tight tracking-tight text-ink" data-id="element-177" data-mp="2jyx7xcpdomut">Wat levert een batterij jou op?</h2>
            <p className="mt-2 text-[15px] text-ink-muted" data-id="element-178" data-mp="2o0s7abnr0q5y">
              We meten je dak op de luchtfoto en maken binnen 60 seconden je persoonlijke advies.
            </p>
            <div className="mt-6" data-id="element-179" data-mp="8asezynq59mc">
              <AddressForm layout="stacked" idPrefix="hero" submitLabel="Start gratis huisscan" data-id="element-180" data-mp="89qruvtfowo9" />
            </div>
            <p className="mt-5 border-t border-line pt-5 text-[13px] text-ink-muted" data-id="element-181" data-mp="3e1r4p5oh9qd">
              Gratis en vrijblijvend. We bellen je alleen als jij daarom vraagt.
            </p>
          </div>
        </div>
      </div>
    </section>;
}